import { Injectable } from '@angular/core';
import { SimpayxOrder } from '../models/simpayx-order.model';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  isThankyouComponentLoaded: boolean = false;
  constructor() {}

  setThankyouComponent() {
    this.isThankyouComponentLoaded = true;
  }

  public static canUseWebP() {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    // very old browser like IE 8, canvas not supported
    return false;
  }
  public static generateOrderId() {
    return Math.floor(Math.random() * 1e16).toString();
  }

  calculateServiceTime(order: SimpayxOrder, timerValue: number): number {
    console.log(order);
    let currentDate = new Date();
    let orderStartDate = new Date(order.paymentInfo.paymentDate.seconds * 1000);
    console.log('payment', orderStartDate);
    let dif = currentDate.getTime() - orderStartDate.getTime();
    console.log('diff', dif);
    dif = Math.floor(dif / 1000);
    timerValue = timerValue - Math.floor(dif / 60);
    console.log(Math.floor(timerValue / 5) * 5);
    return Math.floor(timerValue / 5) * 5;
  }
}
